// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3Leqf","body":"styles-module--body--3Qvt2","container":"styles-module--container--2aAUU"};